"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var module_components_1 = require("@empiriecom/module-components");
var useMeasure_1 = __importDefault(require("@empiriecom/module-components/hooks/useMeasure"));
var getIcon_1 = __importDefault(require("@empiriecom/module-components/utils/getIcon"));
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_media_match_1 = require("react-media-match");
var styled_components_1 = __importDefault(require("styled-components"));
var useConfig_1 = __importDefault(require("../../../hooks/useConfig"));
var submitRegisterForm_1 = __importDefault(require("../HelperFunctions/submitRegisterForm"));
var EmailInput_1 = __importDefault(require("./EmailInput"));
var newsletterSheetTextsPage1 = react_intl_1.defineMessages({
    emailPlaceholder: {
        id: 'nlSheet.emailPlaceholder',
    },
    generalInformationText: {
        id: 'nlSheet.genInfoText',
    },
    voucherCondition: {
        id: 'nlSheet.voucherCondition',
    },
    voucherConditionContent: {
        id: 'nlSheet.voucherConditionContent',
    },
});
var ConditionHead = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  height: 1.5rem;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n\n  svg {\n    transition: all 0.3s ease;\n    ", "\n  }\n"], ["\n  cursor: pointer;\n  height: 1.5rem;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n\n  svg {\n    transition: all 0.3s ease;\n    ", "\n  }\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return isOpen && 'transform: rotate(180deg);';
});
var ConditionBody = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 0.5rem;\n  overflow: hidden;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"], ["\n  margin-bottom: 0.5rem;\n  overflow: hidden;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"])), function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
});
var StyledHeadline = styled_components_1.default(module_components_1.Headline)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 0.813rem;\n  display: none;\n\n  @media only screen and (min-width: ", ") {\n    display: block;\n  }\n"], ["\n  margin-bottom: 0.813rem;\n  display: none;\n\n  @media only screen and (min-width: ", ") {\n    display: block;\n  }\n"])), function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
});
var AnimatedConditionContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  will-change: height;\n  transition: height 0.5s linear;\n"], ["\n  will-change: height;\n  transition: height 0.5s linear;\n"])));
var StyledGeneralInformation = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0.5rem 0 0.8rem 0;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"], ["\n  margin: 0.5rem 0 0.8rem 0;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"])), function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
});
var StyledConditionWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-bottom: 1.5rem solid ", ";\n  overflow: hidden;\n"], ["\n  border-bottom: 1.5rem solid ", ";\n  overflow: hidden;\n"])), function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
});
var Page1 = function (stateFunctions) {
    var _a, _b, _c, _d, _e, _f;
    var setPage = stateFunctions.setPage;
    var intl = react_intl_1.useIntl();
    var config = useConfig_1.default();
    var isMobile = react_media_match_1.useMedia({ mobile: true, tablet: false, desktop: false });
    var ArrowIcon = getIcon_1.default('ArrowMiniDown');
    var _g = react_1.useState(false), stateIsConditionOpen = _g[0], setStateIsOpen = _g[1];
    var _h = useMeasure_1.default(), refCondition = _h[0], contentHeight = _h[1].height;
    var _j = useMeasure_1.default(), refConditionHead = _j[0], contentHeadHeight = _j[1].height;
    var _k = react_1.useState(false), isFormValid = _k[0], setIsFormValid = _k[1];
    var _l = react_1.useState(false), isFormSubmitted = _l[0], setIsFormSubmitted = _l[1];
    var _m = react_1.useState(''), errorMessage = _m[0], setErrorMessage = _m[1];
    function onHeadClick() {
        setStateIsOpen(function (isContentOpen) { return !isContentOpen; });
    }
    return (react_1.default.createElement("div", null,
        !isMobile && (react_1.default.createElement(StyledHeadline, { level: 5, element: "div", tabletMinWidth: (_b = (_a = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.tabletMinWidth },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.genInfoHeadline" }))),
        react_1.default.createElement("form", { "data-testid": "subscribeForm" },
            react_1.default.createElement(EmailInput_1.default, { setIsFormValid: setIsFormValid, setIsFormSubmitted: setIsFormSubmitted, isFormSubmitted: isFormSubmitted, errorMessage: errorMessage }),
            react_1.default.createElement(module_components_1.Button, { layout: "primary", size: "large", onClick: function (event) {
                    event.preventDefault();
                    setIsFormSubmitted(true);
                    return isFormValid && submitRegisterForm_1.default({ setPage: setPage, setErrorMessage: setErrorMessage }, intl, config);
                }, noRipple: true }, isMobile ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.regBtnMob" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.regBtn" })))),
        react_1.default.createElement(StyledGeneralInformation
        // eslint-disable-next-line react/no-danger
        , { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: intl.formatMessage(newsletterSheetTextsPage1.generalInformationText),
            }, tabletMinWidth: (_d = (_c = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.tabletMinWidth }),
        react_1.default.createElement(StyledConditionWrapper, null,
            react_1.default.createElement("div", { ref: refConditionHead },
                react_1.default.createElement(ConditionHead, { "data-testid": "conditionHead", onClick: onHeadClick, isOpen: stateIsConditionOpen },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlSheet.voucherCondition" }),
                    react_1.default.createElement(ArrowIcon, null))),
            react_1.default.createElement(AnimatedConditionContainer, { style: {
                    height: stateIsConditionOpen ? contentHeight + contentHeadHeight : 0,
                } },
                react_1.default.createElement("div", { ref: refCondition },
                    ' ',
                    react_1.default.createElement(ConditionBody, { "data-testid": "conditionContent", dangerouslySetInnerHTML: {
                            __html: intl.formatMessage(newsletterSheetTextsPage1.voucherConditionContent),
                        }, tabletMinWidth: (_f = (_e = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _e === void 0 ? void 0 : _e.values) === null || _f === void 0 ? void 0 : _f.tabletMinWidth }))))));
};
exports.default = Page1;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Page1.js.map